import actionCreatorFactory from 'typescript-fsa';

import { WidgetDTO } from '@topconagriculture/dashboard/build/api/widget/widget.types';

import reduxConfig from '../../../store/config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/automatedReports');

export const setDashboardExclamation = actionCreator<boolean>('SET_DASHBOARD_EXCLAMATION');
export const fetchWidgets = actionCreator.async<{}, WidgetDTO[]>('FETCH_WIDGETS');
